<template>
  <PreviewLayout :item="item" :loading="loading">
    <div>
      <div v-if="item.itemableAttributes.tableTitle" class="tableTitle">
        <span class="tableTitle--text" v-html="previewTitleItem()"></span>
      </div>
      <table class="table">
        <tr v-for="(row, rowIndex) in previewTableContent()" :key="rowIndex">
          <td
            v-for="(col, colIndex) in row"
            :key="colIndex"
            class="table-cell"
            :style="cellStyle(colIndex, rowIndex)"
          >
            <div class="table-div" v-html="returnFilter(col)"></div>
          </td>
        </tr>
      </table>
    </div>
  </PreviewLayout>
</template>

<script>
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import PreviewLayout from './PreviewLayout'

export default {
  name: 'TableItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      titleLintTag: this.textLintAllowTagFormat('title')
    }
  },
  computed: {
    title: function () {
      return this.item.itemableAttributes.tableTitle
    },
    tableContent: function () {
      return this.item.itemableAttributes.tableContent
    },
    lintContent: function () {
      const titleText = `${this.titleLintTag[0]}${this.title}${this.titleLintTag[1]}\n`

      return (
        titleText +
        Object.values(this.tableContent)
          .map((row, rowIndex) => {
            return row
              .map((col, colIndex) => {
                const tags = this.tableContentTag(
                  rowIndex,
                  colIndex,
                  'tableContent'
                )
                return `${tags[0]}${col}${tags[1]}\n`
              })
              .join('')
          })
          .join('')
      )
    }
  },
  mounted () {
    this.setLintAction(this.lintContent)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.lintContent)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  },
  methods: {
    tableContentTag (row, column, item) {
      const tagName = `${row}_${column}_${item}`
      return this.textLintAllowTagFormat(tagName)
    },
    previewTitleItem () {
      return this.parseLintContent(this.titleLintTag) || this.title
    },
    previewTableContent () {
      return Object.values(this.tableContent).map((row, rowIndex) => {
        return row.map((col, colIndex) => {
          const content = this.parseLintContent(
            this.tableContentTag(rowIndex, colIndex, 'tableContent')
          )
          return content || col
        })
      })
    },
    parseLintContent (tag) {
      const previewContentText = this.previewContent(this.lintContent)
      const re = new RegExp(`${tag[0]}[\\s\\S]*${tag[1]}`, 'g')

      if (previewContentText.match(re)) {
        return previewContentText
          .match(re)
          .pop()
          .replace(tag[0], '')
          .replace(tag[1], '')
      }
    },
    returnFilter (val) {
      return val.replace(/\r?\n/g, '<br />')
    },
    cellStyle: function (colIndex, rowIndex) {
      // 横幅設定
      let style = 'width: '
      if (this.item.itemableAttributes.tableContent) {
        style += (
          100 / this.item.itemableAttributes.tableContent[0].length
        ).toString()
      } else {
        style += '100'
      }
      style += '%;'
      // 文字位置設定
      if (this.item.itemableAttributes.tableStyle) {
        let tmpobj = this.item.itemableAttributes.tableStyle
        Object.keys(tmpobj).forEach(function (key) {
          if (colIndex === Number(key)) {
            style += 'text-align: ' + tmpobj[key] + ';'
          }
        })
      }
      // 背景色設定
      if (this.item.itemableAttributes.headerStyle) {
        let obj = this.item.itemableAttributes.headerStyle
        let STRIPE_HEADER_COLOR = '#f7f7f7'
        if (obj['row'] && Number(rowIndex) == 0) {
          if (obj['row'] === 'stripe') {
            style += 'background-color: ' + STRIPE_HEADER_COLOR + ';'
          } else {
            style += 'background-color: white;'
          }
        }
        if (obj['col'] && Number(colIndex) === 0) {
          if (obj['col'] === 'stripe') {
            style += 'background-color: ' + STRIPE_HEADER_COLOR + ';'
          }
        }
      }
      return style
    }
  }
}
</script>

<style scoped lang="sass">
.tableTitle
  text-align: center
  margin-bottom: 12px
  font-weight: bold
  &--text
    border-bottom: 1px solid #f37f77
    padding-bottom: 0.2em
.table
  width: 100%
  table-layout: fixed
  border: 1px double #B4B4B4
.table-cell
  border: 1px solid #e8e8e8
  width: 100%
  padding: 0.5rem
.table-div
  min-height: 1.5rem
</style>
